import {
  MessageCircle,
  Briefcase,
  Award,
  Users,
  CheckSquare,
  Sliders,
  Scale,
  Ear,
} from "lucide-react";

export const TRAITS = [
  { key: "leader", label: "Good Leader", short: "Leadership", category: "leadership", description: "Inspires trust, leads by example, advocates for the team", icon: Award, testid: "leader" },
  { key: "approachable", label: "Approachable", short: "Approachable & Listener", category: "leadership", description: "Easy to talk to and available when you need them", icon: MessageCircle, testid: "approachable" },
  { key: "open_to_feedback", label: "Open to Feedback", short: "Open to Feedback", category: "leadership", description: "I can raise concerns or disagree without it being held against me", icon: Ear, testid: "open-to-feedback" },
  { key: "flexible", label: "Flexible", short: "Flexible & Adaptable", category: "leadership", description: "Accommodating to personal needs and work-life balance", icon: Sliders, testid: "flexible" },
  { key: "fair", label: "Fair & Unbiased", short: "Fairness", category: "leadership", description: "Treats everyone equally, merit-based recognition", icon: Scale, testid: "fair" },
  { key: "managing", label: "Good at Managing", short: "Managing", category: "management", description: "Clear workflow, realistic deadlines and expectations", icon: Briefcase, testid: "managing" },
  { key: "team_management", label: "Team Management", short: "Team Management", category: "management", description: "Fosters healthy dynamics, resolves conflicts fairly", icon: Users, testid: "team-management" },
  { key: "delegating", label: "Good at Delegating", short: "Delegating", category: "management", description: "Trusts team members without micromanaging", icon: CheckSquare, testid: "delegating" },
];

export const LEADERSHIP_TRAITS = TRAITS.filter((t) => t.category === "leadership");
export const MANAGEMENT_TRAITS = TRAITS.filter((t) => t.category === "management");

export function scoreColor(score) {
  if (score >= 4) return "#10B981";
  if (score >= 3) return "#F59E0B";
  return "#F43F5E";
}

export function scoreLabel(score) {
  if (score >= 4.5) return "Outstanding";
  if (score >= 4) return "Great";
  if (score >= 3) return "Good";
  if (score >= 2) return "Mixed";
  if (score > 0) return "Needs Work";
  return "No reviews yet";
}
